module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Regular_web-7fa09cebaab88c4481af9aa6b72c3e09.woff2";